export const meses = () => {
    return [
        { id: 0, text: 'Sin seleccionar' },
        { id: 1, text: 'enero' },
        { id: 2, text: 'febrero' },
        { id: 3, text: 'marzo' },
        { id: 4, text: 'abril' },
        { id: 5, text: 'mayo' },
        { id: 6, text: 'junio' },
        { id: 7, text: 'julio' },
        { id: 8, text: 'agosto' },
        { id: 9, text: 'septiembre' },
        { id: 10, text: 'octubre' },
        { id: 11, text: 'noviembre' },
        { id: 12, text: 'diciembre' }
    ];
};

export const headers_aprob = [ 
    { text: '#', value: 'ind' },
    { text: 'sede portal', value: 'sede_portal_name', width:'130' },  
    { text: 'mes', value: 'mesname' }, 
    { text: 'anio', value: 'anio' },
    { text: 'convenio', value: 'convenio' },
    { text: 'area programa', value: 'area_programa' },
    { text: 'tipo programa', value: 'tipo_programa' },
    { text: 'nombre del programa', value: 'programa_nombre', width:'350' },
    { text: 'codigo', value: 'programa_codigo', width:'120' },
    { text: 'modalidad proyecto', value: 'modalidad_proyecto' },
    { text: 'tipo desarrollo', value: 'tipo_desarrollo' },
    // { text: 'estado_aprobacion', value: 'esta[do_aprobacion' },
    { text: 'estado final', value: 'estado_final' },
    { text: 'fecha inicio campania', value: 'fecha_inicio_campania' },
    { text: 'fecha fin campania', value: 'fecha_fin_campania' },
    { text: 'fecha inicio campania real', value: 'fecha_inicio_campania_reprog' },
    { text: 'fecha fin campania real', value: 'fecha_fin_campania_reprog' },
    // { text: 'fecha_primer_inscrito', value: 'fecha_primer_inscrito' },
    // { text: 'codigo_sys_esam', value: 'codigo_sys_esam' },
    { text: 'inscritos portal', value: 'inscritos_sys_esam' },
    { text: 'coordinador programa', value: 'programa_coordinador' },
    { text: 'dias oferta vigente', value: 'dias_oferta_vigente' },
    { text: 'dias oferta vigente reprog', value: 'dias_oferta_vigente_reprog' },
    { text: 'dias limite', value: 'dias_limite' },
    // { text: 'programa_coordinador_id', value: 'programa_coordinador_id' },
    { text: '', value: 'opt' },
];

export const parseDatos = (listado) => {
    window.console.log('listado>>>>', listado);
    const meses = [
        { id: 0, text: '?' },
        { id: 1, text: 'enero' },
        { id: 2, text: 'febrero' },
        { id: 3, text: 'marzo' },
        { id: 4, text: 'abril' },
        { id: 5, text: 'mayo' },
        { id: 6, text: 'junio' },
        { id: 7, text: 'julio' },
        { id: 8, text: 'agosto' },
        { id: 9, text: 'septiembre' },
        { id: 10, text: 'octubre' },
        { id: 11, text: 'noviembre' },
        { id: 12, text: 'diciembre' }
    ];
    listado.map((x)=>{
        x.mesname = meses[x.mes].text;
    })   
}

export const anios = () => {
    const anioActual = new Date().getFullYear();
    const anioInicio = 2017;
    const anios = [];

    for (let anio = anioInicio; anio <= anioActual; anio++) {
        const a = {text:''+anio, id:anio}
        anios.push(a);
    }
    return anios;
};

export const getMesAnioActual = () => {
    const fechaActual = new Date();  
    const mesActual = fechaActual.getMonth() + 1; 
    const anioActual = fechaActual.getFullYear(); 

    return {
        mes: mesActual,  
        anio: anioActual  
    };
};
